var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSmallUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boeza5bbea",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffec74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1853",
    transform: "translate(-153.865 -1770.018)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 141",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(153.865 1770.018)",
    style: {
      fill: "url(#boeza5bbea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2962",
    d: "M5618.3 306.633v6.108",
    transform: "translate(-5452.797 1470.998)",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "#3e3e3e",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 53",
    transform: "translate(160.5 1787.5)",
    style: {
      strokeWidth: 2,
      fill: "none",
      stroke: "#3e3e3e",
      strokeLinecap: "round"
    },
    d: "M0 0h9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3074",
    d: "m23193.727 82.856 5.178-4.629",
    transform: "translate(-23033.727 1696.765)",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "#3e3e3e",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3075",
    d: "m23198.9 82.856-5.178-4.629",
    transform: "translate(-23028.076 1696.765)",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "#3e3e3e",
      strokeLinecap: "round"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSmallUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-smallUpload.1003171b466cd3097cac3940053168dc.svg";